import React, { useEffect, useState } from "react";
import { ChevronsUpDown, FolderOutput, Loader, MessageSquareText, Send, EllipsisVertical, Repeat2, ClipboardPlus, Stethoscope, Phone, Armchair } from "lucide-react";
import { all_insurance_options, calculateAgeFromDOB, can_visit, caregap_name, notify, sortCaregapsData } from "../../helpers";
import { Link } from "react-router-dom";
import Badge from "../UI/Badge";
import MessageModal from "../Modal/MessageModal";
import LetterModal from "../Modal/LetterModal";
import PatientSingleViewModal from "../Modal/PatientSingleViewModal";
import BulkMessageSendModal from "../Modal/BulkMessageSendModal";
import CallNoteCallModal from "../Modal/CallNoteCallModal";
import CallNoteModal from "../Modal/CallNoteModal";
import CreateOrderModal from "../Modal/CreateOrderModal";
import Skeleton from "react-loading-skeleton";
const maleAvatar = './images/avatar.png';
const femaleAvatar = './images/female.png';
const otherAvatar = './images/other.png';

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function CareGapPlusDataTable(props) {
  const {
    tableData = [],
    handleCheckboxChange = () => {},
    handleSelectAll = () => {},
    checkedIds = [],
    setCheckedIds = () => {},
    checkSelected = false,
    reloadData = () => {},
    reloadDataFilter = {},
    messageTemplate = [],
    account_id,
    location_id,
    smsLimit,
    setSmsLimit = () => {},
    setLetterLimit = () => {},
    dataLoading,
    setDataLoading = () => {},
    exportData = () => {},
    buttonLoader = false,
    globalCheckedIds,
    setGlobalCheckedIds,
    selectedPatientData,
    setSelectedPatientData = () => {},
    handleAddToWaitingRoom = () => {},
    handleReferralNavigation = () => {},
    user_id,
    waitingRoomProviders = [],
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {}
  } = props;

  const [viewStatusOptions, setViewStatusOptions] = useState({});
  const [activePatientViewModal, setActivePatientViewModal] = useState(false);
  const [activeModal, setActiveModal] = useState(false);  
  const [careGapData, setCareGapData] = useState({});
  const [activeLetterModal, setactiveLetterModal] = useState(false);
  const [orderBy, setOrderBy] = useState();
  const [activeCreateOrderModal, setActiveOrderModal] = useState(false);
  const [activeCallNoteModal, setActiveCallNoteModal] = useState(false);
  const [activeCallNoteCallModal, setActiveCallNoteCallModal] = useState(false);
  const [callNoteCallType, setCallNoteCallType] = useState('');
  const [callId, setCallId] = useState(null);
  const [insuranceOptions] = useState(all_insurance_options());
  const [outreachOpen, setOutreachOpen] = useState(false);
  const [startSchedular, setStartSchedular] = useState(false);
  const [showButtonCount, setShowButtonCount] = useState(1);
  const [viewWaitingProviderOptions, setViewWaitingProviderOptions] = useState({});
  const userProviders = waitingRoomProviders;
  const [previousCallScrollPosition, setPreviousCallScrollPosition] = useState(0);

  useEffect(() => {
    if (can_visit('waiting_room') && can_visit('waiting_room_create') && !can_visit('ehr_veradigm')) {
      setShowButtonCount(1);
    } else {
      setShowButtonCount(2);
    }
  }, []);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };
  
  const handleSendMessageModal = (data) => {
    setCareGapData(data)
    setActiveModal(!activeModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleLetterModal = (data) => {
    setCareGapData(data)
    setactiveLetterModal(!activeLetterModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleCallNoteModal = (data) => {
    setCareGapData(data)
    setActiveCallNoteModal(!activeCallNoteModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleCreateOrderModal = (data) => {
    setCareGapData(data)
    setActiveOrderModal(!activeCreateOrderModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handlePatientViewModal = (data) => {
    setCareGapData(data)
    setActivePatientViewModal(!activePatientViewModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleOutsideClick = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setViewStatusOptions({});
    }
    if (!event.target.closest(".dropdown-waiting-container")) {
      setViewWaitingProviderOptions({});
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleDropdownClick = (index) => {
    setViewStatusOptions((prev) => {
      const newViewStatusOptions = {};
      newViewStatusOptions[index] = !prev[index];
      return newViewStatusOptions;
    });
  };

  const handleWaitingDropdownClick = (index) => {
    if(userProviders?.length === 0) {
      notify("error", "Provider not found", 2);
      return;
    }
    setViewWaitingProviderOptions((prev) => {
      const newViewWaitingOptions = {};
      newViewWaitingOptions[index] = !prev[index];
      return newViewWaitingOptions;
    });
  };

  const removeSelection = () => {
    setSelectedPatientData([]);
    setCheckedIds([]);
    setGlobalCheckedIds(new Set());
  };

  const buttonArray = [
    { label: 'Add call note', icon: Phone, isButton: true, action: handleCallNoteModal },
    // { label: 'Add to waiting room', icon: Armchair, isButton: true, action: handleAddToWaitingRoom },
    // { label: 'Create AI chart', icon: ClipboardPlus, isButton: false, action: '/ai-charting/create' },
    { label: 'Create order', icon: Stethoscope, isButton: true, action: handleCreateOrderModal },
    { label: 'Refer patient', icon: Repeat2, isButton: true, action: handleReferralNavigation },
    { label: 'Send letter', icon: Send, isButton: true, action: handleLetterModal },
    { label: 'Send message', icon: MessageSquareText, isButton: true, action: handleSendMessageModal },
  ];
  const permissions = {
    showButton1: can_visit('_call_note'),
    // showButton2: can_visit('waiting_room') && can_visit('waiting_room_create'),
    // showButton2: can_visit('ai_charting') && can_visit('ai_charting_create'),
    showButton2: can_visit('imaging_orders') && can_visit('imaging_orders_create'),
    showButton3: can_visit('easy_referral') && can_visit('easy_referral_create'),
    showButton4: can_visit('letter') && can_visit('_send_letter'),
    showButton5: can_visit('_single_message'),
  };


  return (
    <>
      {checkSelected && (
        <>
          <hr />
          <div className="docpro_data_table_btns">
            {can_visit("_bulk_message") && (
              <BulkMessageSendModal
                // checkedIds={checkedIds}
                messageTemplate={messageTemplate}
                account_id={account_id}
                location_id={location_id}
                smsLimit={smsLimit}
                setSmsLimit={setSmsLimit}
                checkedIds={Array.from(globalCheckedIds)}
                setGlobalCheckedIds={setGlobalCheckedIds}
                selectedPatientData={selectedPatientData}
                setSelectedPatientData={setSelectedPatientData}
              />
            )}
            {can_visit("_bulk_export") && (
              <button
                className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
                onClick={exportData}
                disabled={buttonLoader ? true : false}
              >
                <FolderOutput width={20} height={20} />
                Export All
                {buttonLoader && (
                  <span className="docpro_loading">
                    <Loader width={20} height={20} />
                  </span>
                )}
              </button>
            )}

            {checkedIds?.length > 0 && (
              <div className='docpro_filtered_badge' style={{ margin: 0 }}>
                <span><b>Selected Patients</b>: {checkedIds?.length}</span>
                <button
                  onClick={removeSelection}
                >
                  ✕
                </button>
              </div>
            )}
          </div>
        </>
      )}
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0" style={{ height: "100%" }}>
          <thead>
            <tr>
              <th>
                <div
                  className="docpro_checkbox"
                  style={{ top: "6px", marginRight: "8px" }}
                >
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && tableData.every((row) => globalCheckedIds?.has(row?.id))}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              {can_visit("_role_enterprise") && (
                <>
                  {/* <th 
                    onClick={() => {
                      handleOrderChange("account_name");
                    }}
                    className={orderBy === "account_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Practice Name <ChevronsUpDown size={"12"} />
                    </div>
                  </th>
                  <th 
                    onClick={() => {
                      handleOrderChange("location_name");
                    }}
                    className={orderBy === "location_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Location <ChevronsUpDown size={"12"} />
                    </div>
                  </th> */}
                  <th> Practice Name </th>
                  <th> Location </th>
                </>
              )}
              <th
                onClick={() => {
                  handleOrderChange("last_name");
                }}
                className={orderBy === "last_name" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Last Name <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("first_name");
                  }}
                  className={
                    orderBy === "first_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    First Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("dob");
                }}
                className={orderBy === "dob" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Date of Birth <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("dob");
                }}
                className={orderBy === "dob" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Age <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("sex");
                }}
                className={orderBy === "sex" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Gender <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("mobile_phone");
                }}
                className={
                  orderBy === "mobile_phone" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Phone <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>Quality measure</th>
              <th
                onClick={() => {
                  handleOrderChange("insurance_name");
                }}
                className={
                  orderBy === "insurance_name" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Insurance Name <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("last_visit");
                }}
                className={
                  orderBy === "last_visit" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Last Visited <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th className="docpro_text_center"></th>
            </tr>
          </thead>
          <tbody className="pointer">
            {!dataLoading ? (
              tableData && tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>
                    <td style={{ width: "45px" }}>
                      <div className="docpro_checkbox">
                        <input
                          type="checkbox"
                          checked={globalCheckedIds.has(item.id)}
                          onChange={() => handleCheckboxChange(item.id, item)}
                        />
                        <label></label>
                      </div>
                    </td>

                    {can_visit("_role_enterprise") && (
                      <>
                        <td onClick={() => handlePatientViewModal(item)}>
                          {item.accountName}
                        </td>
                        <td onClick={() => handlePatientViewModal(item)}>
                          {item.locationName}
                        </td>
                      </>
                    )}

                    <td className="bulk" onClick={() => handlePatientViewModal(item)}>
                      <div className="flex items-center table_img">
                        <img src={item.sex === "Male" ? maleAvatar : item.sex === "Female" ? femaleAvatar : otherAvatar} alt="User" />
                        {item.lastName}
                      </div>
                    </td>
                    <td
                      className="bulk"
                      onClick={() => handlePatientViewModal(item)}
                    >
                      {item.firstName}
                    </td>

                    <td onClick={() => handlePatientViewModal(item)}>
                      {item.dob}
                    </td>
                    <td onClick={() => handlePatientViewModal(item)}>
                      {calculateAgeFromDOB(item.dob)}y
                    </td>
                    <td onClick={() => handlePatientViewModal(item)}>
                      {item.sex}
                    </td>
                    <td
                      className="bulk"
                      onClick={() => handlePatientViewModal(item)}
                    >
                      {item.mobilePhone}
                    </td>
                    <td onClick={() => handlePatientViewModal(item)}>
                      {item.care_gaps &&
                        sortCaregapsData(item.care_gaps).map((x, index) => (
                          reloadDataFilter?.quality_measure?.length !== 0 && reloadDataFilter?.quality_measure?.some(search_item => search_item.id === x.care_gap_id) ?
                            <p key={index}>
                              {x.status === "pending" && (
                                <span style={{ marginRight: "8px" }}>
                                  <Badge color="orange">Pending</Badge>
                                </span>
                              )}
                              {x.status === "scheduled" && (
                                <span style={{ marginRight: "8px" }}>
                                  <Badge color="blue">Scheduled</Badge>
                                </span>
                              )}
                              {x.status === "completed" && (
                                <span style={{ marginRight: "8px" }}>
                                  <Badge color="green">Done</Badge>
                                </span>
                              )}
                              {caregap_name(x.care_gap_id)}
                            </p>
                          :
                            reloadDataFilter?.quality_measure?.length === 0 && (
                              <p key={index}>
                                {x.status === "pending" && (
                                  <span style={{ marginRight: "8px" }}>
                                    <Badge color="orange">Pending</Badge>
                                  </span>
                                )}
                                {x.status === "scheduled" && (
                                  <span style={{ marginRight: "8px" }}>
                                    <Badge color="blue">Scheduled</Badge>
                                  </span>
                                )}
                                {x.status === "completed" && (
                                  <span style={{ marginRight: "8px" }}>
                                    <Badge color="green">Done</Badge>
                                  </span>
                                )}
                                {caregap_name(x.care_gap_id)}
                              </p>
                            )
                        ))
                      }
                    </td>
                    <td onClick={() => handlePatientViewModal(item)}>
                      {item.insuranceName}
                    </td>
                    <td onClick={() => handlePatientViewModal(item)}>
                      {item.lastVisit}
                    </td>
                    <td className="bulk hidden">
                      {item.id}
                    </td>
                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns">
                        {buttonArray
                          .filter((_, index1) => permissions[`showButton${index1 + 1}`])
                          .slice(0, showButtonCount)
                          .map((btn, btnIndex) => (
                            <div key={btnIndex}>
                              {btn.isButton ? (
                                <button type="button" className="docpro_icon_btn" onClick={() => btn.action(item)}>
                                  <btn.icon width={18} height={18} />
                                  <span className="docpro_tip">{btn.label}</span>
                                </button>
                              ) : (
                                <Link to={`${btn.action}?patient_id=${item.id}`}>
                                  <button type="button" className="docpro_icon_btn">
                                    <btn.icon width={18} height={18} />
                                    <span className="docpro_tip">{btn.label}</span>
                                  </button>
                                </Link>
                              )}
                            </div>
                          ))
                        }
                        {(can_visit('waiting_room') && can_visit('waiting_room_create') && !can_visit('ehr_veradigm')) && (
                          <div className="dropdown-waiting-container" style={{ position: 'relative' }}>
                            <button className="docpro_icon_btn" onClick={() => handleWaitingDropdownClick(index)}>
                              <Armchair width={18} height={18} />
                              <span className="docpro_tip">Add to waiting room</span>
                            </button>
                            {viewWaitingProviderOptions[index] && (
                              <div className={`docpro_button_toggle_options ${index > 4 && 'top_position'}`}>
                                {userProviders?.length > 0 ? (
                                  userProviders?.map((provider, index2) => (
                                    <p key={index2} onClick={() => {handleAddToWaitingRoom(item, provider?.provider_id); setViewWaitingProviderOptions({})}}>{provider?.first_name}{' '}{provider?.last_name}</p>
                                  )
                                )) : (
                                  <p className="docpro_red_color" style={{ cursor: 'auto' }}>Providers not found</p>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        {buttonArray?.length > showButtonCount &&
                          buttonArray.filter((_, index2) => permissions[`showButton${index2 + 1}`]).length > showButtonCount && (
                            <div className="dropdown-container relative">
                              <button className="docpro_icon_btn" onClick={() => handleDropdownClick(index)}>
                                <EllipsisVertical width={18} height={18} />
                              </button>
                              {viewStatusOptions[index] && (
                                <div className={`docpro_button_toggle_options ${index > 4 && 'top_position'}`}>
                                  {buttonArray
                                    .filter((_, index2) => permissions[`showButton${index2 + 1}`])
                                    .slice(showButtonCount)
                                    .map((btn, btnIndex) => (
                                      <div key={btnIndex}>
                                        {btn.isButton ? (
                                          <button
                                            type="button"
                                            className="docpro_icon_btn docpro_dropdown_button"
                                            onClick={() => btn.action(item)}
                                          >
                                            <btn.icon width={18} height={18} />
                                            <span>{btn.label}</span>
                                          </button>
                                        ) : (
                                          <Link to={`${btn.action}?patient_id=${item.id}`}>
                                            <button type="button" className="docpro_icon_btn docpro_dropdown_button">
                                              <btn.icon width={18} height={18} />
                                              <span>{btn.label}</span>
                                            </button>
                                          </Link>
                                        )}
                                      </div>
                                    ))}
                                </div>
                              )}
                            </div>
                          )
                        }
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan={`${can_visit("_role_enterprise") ? 13 : 11}`}>
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                  {can_visit("_role_enterprise") && (
                    <>
                      <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                      <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                    </>
                  )}
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${3 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="6rem" borderRadius="8px"></Skeleton> </td>
                  <td>
                    {Array.from({ length: 3 }).map((_, index2) => (
                      <Skeleton key={index2} width={`${5 + ((index + index2) % 1.5)}rem`} borderRadius="8px" />
                    ))}
                  </td>
                  <td> <Skeleton width={`${5.5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td className="text-right"> <span className="mr-4 pr-2"><Skeleton width="3rem" borderRadius="8px"></Skeleton></span> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {activeModal && (
        <MessageModal
          patient_id={careGapData.id}
          last_name={careGapData.lastName}
          first_name={careGapData.firstName}
          phone={careGapData.mobilePhone}
          messageTemplate={messageTemplate}
          tooltip={true}
          account_id={account_id}
          location_id={location_id}
          activeModal={activeModal}
          setActiveModal={setActiveModal}
          setSmsLimit={setSmsLimit}
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {activeLetterModal && (
        <LetterModal
          last_name={careGapData.lastName}
          first_name={careGapData.firstName}
          address={careGapData.address}
          messageTemplate={messageTemplate}
          account_id={account_id}
          location_id={location_id}
          activeModal={activeLetterModal}
          setActiveModal={setactiveLetterModal}
          setLetterLimit={setLetterLimit}
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {activeCreateOrderModal && (
        <CreateOrderModal
          last_name={careGapData.lastName}
          first_name={careGapData.firstName}
          phone={careGapData.mobilePhone}
          patient_id = {careGapData.id}
          insurance_name = {careGapData.insuranceName}
          insurance_code = { careGapData.insurance_code}
          zip_code = { careGapData.zip_code}
          user_id={user_id}
          account_id={account_id}
          location_id={location_id}
          activeModal={activeCreateOrderModal}
          setActiveModal={setActiveOrderModal}
          setSmsLimit={setSmsLimit}
          previousScrollPosition={previousScrollPosition}
        />
      )}


      {activePatientViewModal && (
        <PatientSingleViewModal
          practice_id={careGapData.practiceId}
          patient_id={careGapData.id}
          reloadData={reloadData}
          reloadDataFilter={reloadDataFilter}
          messageTemplate={messageTemplate}
          account_id={account_id}
          location_id={location_id}
          insuranceOptions={insuranceOptions}
          activeModal={activePatientViewModal}
          setActiveModal={setActivePatientViewModal}
          setSmsLimit={setSmsLimit}
          outreachOpen={outreachOpen}
          setOutreachOpen={setOutreachOpen}
          startSchedular={startSchedular}
          setStartSchedular={setStartSchedular}
          callNoteCallType={callNoteCallType}
          setCallNoteCallType={setCallNoteCallType}
          setActiveCallNoteCallModal={setActiveCallNoteCallModal}
          callId={callId}
          previousScrollPosition={previousScrollPosition}
          setPreviousCallScrollPosition={setPreviousCallScrollPosition}
        />
      )}

      {activeCallNoteModal && (
        <CallNoteModal
          patient_data={careGapData} 
          activeModal={activeCallNoteModal}
          setActiveModal={setActiveCallNoteModal}
          setCallNoteCallType={setCallNoteCallType}
          setActiveCallNoteCallModal={setActiveCallNoteCallModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousCallScrollPosition={setPreviousCallScrollPosition}
        />
      )}

      {activeCallNoteCallModal && (
        <CallNoteCallModal
          account_id={account_id}
          location_id={location_id}
          patient_data={careGapData}
          callNoteCallType={callNoteCallType}
          activeModal={activeCallNoteCallModal}
          setActiveModal={setActiveCallNoteCallModal}
          setOutreachOpen={setOutreachOpen}
          setActivePatientViewModal={setActivePatientViewModal}
          startSchedular={startSchedular}
          setStartSchedular={setStartSchedular}
          smsLimit={smsLimit}
          setCallId={setCallId}
          previousCallScrollPosition={previousCallScrollPosition}
        />
      )}
    </>
  );
}
